var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"height":"100%"}},[_c('el-aside',{attrs:{"width":"200px"}},[_c('common-aside')],1),_c('el-container',[_c('el-header',[_c('common-header')],1),_c('common-tab'),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }